module.exports = "<div class=\"_user-detail-view\">\n\n  <v-layout row justify-center>\n\n    <v-flex xs12>\n      <transition name=\"fade\">\n        <!--<cm-automation-details></cm-automation-details>-->\n        <cm-user-details></cm-user-details>\n      </transition>\n    </v-flex>\n\n  </v-layout>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/userDetailView/userDetailView.vue
// module id = 389
// module chunks = 0